module.exports = "https://cdn.realtymogul.com/static/media/HP_card_turtle_crossing.f2b4db65.jpg";